import { render, staticRenderFns } from "./ProposalEvaluationDocuments.vue?vue&type=template&id=079f8112&scoped=true"
import script from "./ProposalEvaluationDocuments.vue?vue&type=script&lang=js"
export * from "./ProposalEvaluationDocuments.vue?vue&type=script&lang=js"
import style0 from "./ProposalEvaluationDocuments.vue?vue&type=style&index=0&id=079f8112&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079f8112",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('079f8112')) {
      api.createRecord('079f8112', component.options)
    } else {
      api.reload('079f8112', component.options)
    }
    module.hot.accept("./ProposalEvaluationDocuments.vue?vue&type=template&id=079f8112&scoped=true", function () {
      api.rerender('079f8112', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/proposalHistory/components/ProposalEvaluationDocuments.vue"
export default component.exports